import { memo } from "react";

const { TableRow, TableCell } = require("@material-ui/core");

const GroupTotalRow = ({ total, columns }) => {
  const formattedTotal = `${(total.amount ?? 0).toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 5,
  })}`;

  return (
    <TableRow style={{ backgroundColor: "#d6e5ff" }}>
      <TableCell size="small" colSpan={6}>
        Total
      </TableCell>
      <TableCell size="small" colSpan={1} align="right">
        {formattedTotal}
      </TableCell>
      <TableCell size="small" colSpan={columns.length - 7} />
    </TableRow>
  );
};

export default memo(GroupTotalRow);
